import React from 'react'
import { ResponsiveLayout } from 'containers'
import Header from 'containers/ResponsiveLayout/Header'
import { MyNetworkWithRollout } from './MyNetworkWithRollout'

const MyNetwork = () => {
  return (
    <ResponsiveLayout menu={<Header />} content={<MyNetworkWithRollout />} />
  )
}

export default MyNetwork
